var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wkb-inspector", class: { "is-open": _vm.open } },
    [
      _c(
        "button",
        {
          staticClass: "wkb-inspector-tab",
          attrs: {
            type: "button",
            "aria-expanded": _vm.open ? "true" : "false",
          },
          on: {
            click: function ($event) {
              return _vm.$emit("toggle")
            },
          },
        },
        [
          _c("span", { staticClass: "wkb-inspector-tab-label" }, [
            _vm._v("Inspector"),
          ]),
        ]
      ),
      _c(
        "aside",
        {
          staticClass: "wkb-inspector-panel",
          attrs: { role: "complementary", "aria-label": "Inspector" },
        },
        [
          _c("header", { staticClass: "wkb-inspector-head" }, [
            _c("h3", { staticClass: "wkb-inspector-title" }, [
              _vm._v("Inspector"),
            ]),
            _c(
              "button",
              {
                staticClass: "wkb-inspector-close",
                attrs: { type: "button", "aria-label": "Close inspector" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("toggle")
                  },
                },
              },
              [_vm._v(" × ")]
            ),
          ]),
          _c("div", { staticClass: "wkb-inspector-body" }, [
            _c(
              "div",
              {
                key: _vm.inspectorContentKey || "inspector-empty",
                staticClass: "wkb-inspector-content",
              },
              [
                _vm.geneSetInspectorContext
                  ? _c("WorkspaceGeneSetNodeInspectorContent", {
                      attrs: {
                        node: _vm.geneSetInspectorContext.node,
                        "key-node-items":
                          _vm.geneSetInspectorContext.keyNodeItems,
                        "session-context":
                          _vm.geneSetInspectorContext.sessionContext,
                        "graph-nodes": _vm.geneSetInspectorContext.graphNodes,
                        "graph-edges": _vm.geneSetInspectorContext.graphEdges,
                        "contextual-edges":
                          _vm.geneSetInspectorContext.contextualEdges,
                        "connection-cache":
                          _vm.geneSetInspectorContext.connectionCache,
                        "api-client": _vm.apiClient,
                        "graph-busy": _vm.graphBusy,
                      },
                      on: {
                        "cache-connections": function ($event) {
                          return _vm.$emit("cache-connections", $event)
                        },
                        "add-node": function ($event) {
                          return _vm.$emit("add-node", $event)
                        },
                        "remove-node": function ($event) {
                          return _vm.$emit("remove-node", $event)
                        },
                        "inspect-connected-edge": function ($event) {
                          return _vm.$emit("inspect-connected-edge", $event)
                        },
                        "inspect-connected-node": function ($event) {
                          return _vm.$emit("inspect-connected-node", $event)
                        },
                      },
                    })
                  : _vm.mechanismInspectorContext
                  ? _c("WorkspaceMechanismNodeInspectorContent", {
                      attrs: {
                        node: _vm.mechanismInspectorContext.node,
                        "key-node-items":
                          _vm.mechanismInspectorContext.keyNodeItems,
                        "session-context":
                          _vm.mechanismInspectorContext.sessionContext,
                        "graph-nodes": _vm.mechanismInspectorContext.graphNodes,
                        "graph-edges": _vm.mechanismInspectorContext.graphEdges,
                        "contextual-edges":
                          _vm.mechanismInspectorContext.contextualEdges,
                        "connection-cache":
                          _vm.mechanismInspectorContext.connectionCache,
                        "factor-loadings-cache":
                          _vm.mechanismInspectorContext.factorLoadingsCache,
                        "factor-loadings-loading":
                          _vm.mechanismInspectorContext.factorLoadingsLoading,
                        "factor-loadings-error":
                          _vm.mechanismInspectorContext.factorLoadingsError,
                        "sig-chain-packet":
                          _vm.mechanismInspectorContext.sigChainPacket,
                        "sig-chain-loading":
                          _vm.mechanismInspectorContext.sigChainLoading,
                        "sig-chain-error":
                          _vm.mechanismInspectorContext.sigChainError,
                        "api-client": _vm.apiClient,
                        "graph-busy": _vm.graphBusy,
                      },
                      on: {
                        "cache-connections": function ($event) {
                          return _vm.$emit("cache-connections", $event)
                        },
                        "cache-factor-loadings": function ($event) {
                          return _vm.$emit("cache-factor-loadings", $event)
                        },
                        "load-factor-loadings": function ($event) {
                          return _vm.$emit("load-factor-loadings", $event)
                        },
                        "add-node": function ($event) {
                          return _vm.$emit("add-node", $event)
                        },
                        "remove-node": function ($event) {
                          return _vm.$emit("remove-node", $event)
                        },
                        "inspect-connected-edge": function ($event) {
                          return _vm.$emit("inspect-connected-edge", $event)
                        },
                        "inspect-connected-node": function ($event) {
                          return _vm.$emit("inspect-connected-node", $event)
                        },
                      },
                    })
                  : _vm.traitInspectorContext
                  ? _c("WorkspaceTraitNodeInspectorContent", {
                      attrs: {
                        node: _vm.traitInspectorContext.node,
                        "key-node-items":
                          _vm.traitInspectorContext.keyNodeItems,
                        "session-context":
                          _vm.traitInspectorContext.sessionContext,
                        "graph-nodes": _vm.traitInspectorContext.graphNodes,
                        "graph-edges": _vm.traitInspectorContext.graphEdges,
                        "contextual-edges":
                          _vm.traitInspectorContext.contextualEdges,
                        "connection-cache":
                          _vm.traitInspectorContext.connectionCache,
                        "sig-chain-packet":
                          _vm.traitInspectorContext.sigChainPacket,
                        "sig-chain-loading":
                          _vm.traitInspectorContext.sigChainLoading,
                        "sig-chain-error":
                          _vm.traitInspectorContext.sigChainError,
                        "api-client": _vm.apiClient,
                        "graph-busy": _vm.graphBusy,
                      },
                      on: {
                        "cache-connections": function ($event) {
                          return _vm.$emit("cache-connections", $event)
                        },
                        "add-node": function ($event) {
                          return _vm.$emit("add-node", $event)
                        },
                        "remove-node": function ($event) {
                          return _vm.$emit("remove-node", $event)
                        },
                        "inspect-connected-edge": function ($event) {
                          return _vm.$emit("inspect-connected-edge", $event)
                        },
                        "inspect-connected-node": function ($event) {
                          return _vm.$emit("inspect-connected-node", $event)
                        },
                      },
                    })
                  : _vm.geneInspectorContext
                  ? _c("WorkspaceGeneNodeInspectorContent", {
                      attrs: {
                        node: _vm.geneInspectorContext.node,
                        "key-node-items": _vm.geneInspectorContext.keyNodeItems,
                        "session-context":
                          _vm.geneInspectorContext.sessionContext,
                        "graph-nodes": _vm.geneInspectorContext.graphNodes,
                        "graph-edges": _vm.geneInspectorContext.graphEdges,
                        "contextual-edges":
                          _vm.geneInspectorContext.contextualEdges,
                        "connection-cache":
                          _vm.geneInspectorContext.connectionCache,
                        "expression-cache":
                          _vm.geneInspectorContext.expressionCache,
                        "preferred-expression-reference-id":
                          _vm.geneInspectorContext
                            .preferredExpressionReferenceId,
                        "expression-options": _vm.expressionOptions,
                        "api-client": _vm.apiClient,
                        "graph-busy": _vm.graphBusy,
                      },
                      on: {
                        "cache-connections": function ($event) {
                          return _vm.$emit("cache-connections", $event)
                        },
                        "cache-expression": function ($event) {
                          return _vm.$emit("cache-expression", $event)
                        },
                        "add-node": function ($event) {
                          return _vm.$emit("add-node", $event)
                        },
                        "remove-node": function ($event) {
                          return _vm.$emit("remove-node", $event)
                        },
                        "inspect-connected-edge": function ($event) {
                          return _vm.$emit("inspect-connected-edge", $event)
                        },
                        "inspect-connected-node": function ($event) {
                          return _vm.$emit("inspect-connected-node", $event)
                        },
                      },
                    })
                  : _vm.selectedEdgeId && _vm.selectedEdge
                  ? _c("WorkspaceEdgeInspectorContent", {
                      attrs: {
                        "selected-edge": _vm.selectedEdge,
                        payload: _vm.selectedEdge.provenancePayload,
                        "provenance-loading":
                          _vm.selectedEdge.provenanceLoading,
                        "provenance-error": _vm.selectedEdge.provenanceError,
                        "api-client": _vm.apiClient,
                        "graph-busy": _vm.graphBusy,
                        "graph-nodes": _vm.graphNodes,
                      },
                      on: {
                        "add-node": function ($event) {
                          return _vm.$emit("add-node", $event)
                        },
                        "remove-node": function ($event) {
                          return _vm.$emit("remove-node", $event)
                        },
                      },
                    })
                  : _vm.selectedNode
                  ? [
                      _c("p", { staticClass: "wkb-inspector-node-name" }, [
                        _vm._v(_vm._s(_vm.selectedNode.label)),
                      ]),
                      _c("dl", { staticClass: "wkb-inspector-meta" }, [
                        _vm.selectedNode.nodeType
                          ? _c("div", [
                              _c("dt", [_vm._v("Type")]),
                              _c("dd", [
                                _vm._v(_vm._s(_vm.selectedNode.nodeType)),
                              ]),
                            ])
                          : _vm._e(),
                        _vm.selectedNode.isKeyNode
                          ? _c("div", [
                              _c("dt", [_vm._v("Role")]),
                              _c("dd", [_vm._v("Selected node")]),
                            ])
                          : _vm._e(),
                        _vm.selectedNode.subtitle
                          ? _c("div", [
                              _c("dt", [_vm._v("Subtitle")]),
                              _c("dd", [
                                _vm._v(_vm._s(_vm.selectedNode.subtitle)),
                              ]),
                            ])
                          : _vm._e(),
                        _vm.selectedNode.rationale
                          ? _c("div", [
                              _c("dt", [_vm._v("Rationale")]),
                              _c("dd", [
                                _vm._v(_vm._s(_vm.selectedNode.rationale)),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                      _c("p", { staticClass: "wkb-inspector-note" }, [
                        _vm._v(" Use "),
                        _c("strong", [_vm._v("Inspect node")]),
                        _vm._v(
                          " on gene, trait, mechanism, or gene set nodes for full evidence. "
                        ),
                      ]),
                    ]
                  : _vm.selectedNodeId
                  ? [
                      _c("p", { staticClass: "wkb-inspector-node-name" }, [
                        _vm._v(_vm._s(_vm.selectedNodeId)),
                      ]),
                      _c(
                        "p",
                        {
                          staticClass:
                            "wkb-inspector-note wkb-inspector-note--warn",
                        },
                        [
                          _vm._v(
                            " This node is no longer on the graph. Choose another node on the canvas. "
                          ),
                        ]
                      ),
                    ]
                  : _c("p", { staticClass: "wkb-inspector-empty" }, [
                      _vm._v(
                        " Select a node or edge in the graph to see the associations behind it. "
                      ),
                    ]),
              ],
              2
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }